// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/inventory-order/tabs/order-history/order-history.less
// module id = 3568
// module chunks = 0